<template>
  <v-row>
    <v-col
      v-for="(item, i) in tabs"
      :key="i"
      cols="auto"
    >
      <v-btn
        :text="!tab_selected(item)"
        :to="`/content/${item.id}`"
      >
        {{ item.name }}
      </v-btn>
    </v-col>
    <v-spacer />
    <v-col
      cols="auto"
      class="mt-auto mr-4"
    >
      <v-btn
        v-if="showFilter"
        icon
        small
        class="mr-2"
        @click="filter"
      >
        <v-icon>filter_list</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ContentHeader',
  components: {},
  data() {
    return { saving: false };
  },
  computed: {
    tabs() {
      let list = this.$enums.CONTENT_TABS;

      if (!this.is_admin) {
        list = list.filter((x) => x.allowContentAdmin);
      }

      return list;
    },
    id() {
      return this.$route.params.id;
    },
    tab_selected() {
      return (item) => {
        return this.id === item.id;
      };
    },
    showFilter() {
      return (
        this.id !== 'authors' &&
        this.id !== 'prompts' &&
        this.id !== 'images' &&
        this.id !== 'questions' &&
        this.id !== 'pages'
      );
    },
    ...mapGetters({ is_admin: 'auth/is_admin' })
  },
  methods: {
    filter() {
      switch (this.id) {
        case 'catalog':
          this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.FILTER_CATALOG_PAGE_SHOW, {});
          break;
        case 'blogposts':
          this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.FILTER_BLOG_POST_SHOW, {});
          break;
      }
    }
  }
};
</script>
